import React from 'react';
import SummaryCard from '../shared/SummaryCard';

const LighthouseSection = ({ lighthouseReport, onViewReport }) => {
    if (!lighthouseReport) {
        return null;
    }

    // Extract category scores from Lighthouse report
    const categories = lighthouseReport.categories || {};
    const categoryScores = [];

    // Common Lighthouse categories
    const categoryMap = {
        'performance': 'Performance',
        'accessibility': 'Accessibility',
        'best-practices': 'Best Practices',
        'seo': 'SEO'
    };

    // Extract scores and format them
    Object.keys(categoryMap).forEach(key => {
        const category = categories[key];
        if (category && category.score !== null && category.score !== undefined) {
            // Lighthouse scores are 0-1, convert to 0-100
            const score = Math.round(category.score * 100);
            categoryScores.push({
                label: categoryMap[key],
                value: `${score}`,
                score: score
            });
        }
    });

    if (categoryScores.length === 0) {
        return null;
    }

    // Get score color based on value
    const getScoreColor = (score) => {
        if (score >= 90) return '#10b981'; // green
        if (score >= 50) return '#f59e0b'; // orange
        return '#ef4444'; // red
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Lighthouse Audit</h4>
                <button
                    onClick={onViewReport}
                    style={{
                        backgroundColor: '#3a3a3a',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 14px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4a4a4a'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                >
                    View complete report
                </button>
            </div>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    fontSize: '12px',
                    color: '#a0a0a0',
                    textTransform: 'uppercase',
                    marginBottom: '12px',
                    fontWeight: '600',
                    letterSpacing: '0.5px'
                }}>
                    Category Scores
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                    gap: '15px'
                }}>
                    {categoryScores.map(({ label, value, score }) => (
                        <div
                            key={label}
                            style={{
                                backgroundColor: '#262626',
                                border: '1px solid #373737',
                                borderRadius: '6px',
                                padding: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px'
                            }}
                        >
                            <div style={{
                                fontSize: '12px',
                                color: '#909090',
                                textTransform: 'uppercase',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                {label}
                            </div>
                            <div style={{
                                fontSize: '24px',
                                color: getScoreColor(score),
                                fontWeight: '600'
                            }}>
                                {value}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LighthouseSection;






